export const BACKEND_URL = `https://api.izilifepay.com/api`;
